import settings from 'settings'

export const getUrl = (projectid, path, token) => {
  const base = [settings.api, '/storage/download', projectid].join('/').replace(/\/+/g, '/')
  let url = base + '?filepath=' + encodeURIComponent(path)
  if(token) {
    url += '&token=' + encodeURIComponent(token)
  }
  return url
}
